module.exports = __webpack_public_path__ + "img/ajs-climatic.4b7b31c8.png";